/**
 * Create a custom event.
 * @template {object} T
 * @param {string} type
 * @param {CustomEventInit} options
 * @param {T} [detail]
 * @returns {CustomEvent<T>}
 */
export function createCustomEvent(
  type,
  options = {
    bubbles: true,
    composed: true,
  },
  detail = {},
) {
  return new CustomEvent(type, { ...options, detail });
}
